import { Loader2 } from 'lucide-react';

export interface SpinnerProps {
  /** Icon size in px. Default 20. */
  size?: number;
  className?: string;
}

/** Spinning loader icon (lucide Loader2). */
export function Spinner({ size = 20, className }: SpinnerProps) {
  return (
    <Loader2
      size={size}
      role="status"
      aria-label="Loading"
      className={['animate-spin', className].filter(Boolean).join(' ')}
    />
  );
}
